import * as yup from 'yup';

export const checksValidationSchema = {
    checks: yup.array().of(
        yup.object().shape({
            bank: yup.string().required('Bank is required'),
            account: yup.string().required('Account is required'),
            number: yup.string().required('Number is required'),
            amount: yup.number().required('Amount is required'),
            valueDate: yup.date().nullable().required('Value Date is required')
        })
    )
};
